// sites.index.tsx
// Route: /sites — list of sites accessible by the current user.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { SitesPage } from "@/presentation/pages/SitesPage";

const sitesSearchSchema = z.object({
  siteSize: z.string().min(1).optional(),
});

interface SitesSearch {
  siteSize?: string;
}

export const Route = createFileRoute("/sites/")({
  component: function SitesRouteComponent() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();

    return (
      <SitesPage
        siteSizeFilter={search.siteSize}
        onSiteSizeFilterChange={(siteSize) =>
          void navigate({
            search: { siteSize: siteSize || undefined },
            replace: true,
          })
        }
      />
    );
  },
  validateSearch: (search: Record<string, unknown>): SitesSearch => {
    const parsed = sitesSearchSchema.safeParse(search);
    return parsed.success ? parsed.data : {};
  },
});
